import { formatMontant } from '@mairistem/finances-utils';
import TypeBudget from '../../constants/simulation/typeBudget';
import type Simulation from '../../interfaces/simulation/simulation';

const INTRODUCTION =
	"La section de fonctionnement regroupe l'ensemble des dépenses et des recettes nécessaires au fonctionnement courant et récurrent des services.";

class SectionFonctionnement {
	simulation: Simulation;

	constructor(simulation: Simulation) {
		this.simulation = simulation;
	}

	getTitre(): string {
		return '2. La section de fonctionnement';
	}

	getContenu(): string {
		if (this.simulation.budget?.type !== TypeBudget.BUDGET_PRIMITIF) {
			return '';
		}

		const annee = this.simulation.exercice?.anneeExercice;
		const depenseFonctionnement =
			this.simulation.panelData?.prop?.depenseFonctionnement ?? 0;
		const recetteFonctionnement =
			this.simulation.panelData?.prop?.recetteFonctionnement ?? 0;

		if (depenseFonctionnement === recetteFonctionnement) {
			return `${INTRODUCTION}\n\nLes dépenses et recettes de fonctionnement ${annee} s'élèvent à ${formatMontant(depenseFonctionnement, 2, true)}.`;
		}

		return `${INTRODUCTION}\n\nLes dépenses de fonctionnement ${annee} s'élèvent à ${formatMontant(depenseFonctionnement, 2, true)} et les recettes de fonctionnement ${annee} à ${formatMontant(recetteFonctionnement, 2, true)}.`;
	}
}

export default SectionFonctionnement;
